module.exports = __webpack_public_path__ + "media/images/lp_mv-img-7a9a8787c50030717a5c03cb5cb46737.webp";